import { useState, useEffect } from "react";
import { apiGet, apiSend, errorMessage } from "./api";
import "./InvitationAccept.css";

// Création du compte gérant depuis le lien reçu par e-mail. Page publique :
// le destinataire n'a pas encore de compte, c'est la connaissance du jeton
// qui l'autorise.
function InvitationAccept({ token }) {
  const [invite, setInvite] = useState(null);
  const [loadError, setLoadError] = useState("");
  const [loading, setLoading] = useState(true);

  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [siret, setSiret] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    apiGet(`/api/invitations/${token}`, "Lien d'invitation invalide")
      .then(setInvite)
      .catch((e) => setLoadError(errorMessage(e, "Lien d'invitation invalide")))
      .finally(() => setLoading(false));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    // Vérifié côté client uniquement pour le confort : le serveur impose la
    // longueur minimale, c'est lui qui fait autorité.
    if (password !== confirm) {
      setError("Les deux mots de passe ne correspondent pas.");
      return;
    }
    const cleanSiret = siret.replace(/\s/g, "");
    if (!/^\d{14}$/.test(cleanSiret)) {
      setError("Le SIRET doit comporter 14 chiffres.");
      return;
    }
    setError("");
    setSaving(true);
    try {
      await apiSend(`/api/invitations/${token}/accept`, "POST",
        { name, surname, password, siret: cleanSiret },
        "Impossible de créer le compte");
      setDone(true);
      return;
    } catch (e) {
      setError(errorMessage(e, "Impossible de créer le compte"));
    }
    setSaving(false);
  };

  return (
    <div className="inv-page">
      <div className="inv-card">
        <span className="rc-wordmark inv-brand">Racines</span>
        <p className="inv-tagline">Cartes de fidélité · Commerces de proximité</p>

        {loading ? (
          <p className="inv-muted">Vérification du lien...</p>
        ) : loadError ? (
          <>
            <h1>Lien invalide</h1>
            <p className="inv-muted">{loadError}</p>
            <p className="inv-muted">
              Les invitations expirent au bout de 7 jours et ne servent qu'une
              fois. Demandez-en une nouvelle à votre conseiller.
            </p>
          </>
        ) : done ? (
          <>
            <h1>Compte créé</h1>
            <p className="inv-muted">
              Votre compte <strong>{invite.email}</strong> est enregistré avec le
              mot de passe que vous venez de choisir.
            </p>
            <p className="inv-muted">
              Dernière étape : connectez-vous et choisissez votre formule
              d'abonnement. <strong>Attention</strong> — sans souscription dans
              les 30 minutes, votre inscription sera annulée et il faudra
              demander une nouvelle invitation.
            </p>
            <a className="rc-btn rc-btn-primary inv-btn" href="/">Se connecter</a>
          </>
        ) : (
          <>
            <h1>Créez votre compte</h1>
            <p className="inv-muted">
              Commerce : <strong>{invite.organization}</strong>
              <br />
              Adresse : <strong>{invite.email}</strong>
            </p>
            <form onSubmit={submit}>
              {error && <div className="inv-error">{error}</div>}
              <label>Prénom</label>
              <input value={surname} onChange={(e) => setSurname(e.target.value)}
                     maxLength={50} required />
              <label>Nom</label>
              <input value={name} onChange={(e) => setName(e.target.value)}
                     maxLength={50} required />
              <label>SIRET de votre commerce</label>
              <input value={siret} onChange={(e) => setSiret(e.target.value)}
                     inputMode="numeric" placeholder="123 456 789 00012"
                     maxLength={20} required />
              <p className="inv-hint">
                14 chiffres — il figurera sur vos factures.
              </p>
              <label>Mot de passe</label>
              <input type="password" value={password} minLength={8} maxLength={128}
                     onChange={(e) => setPassword(e.target.value)} required />
              <label>Confirmer le mot de passe</label>
              <input type="password" value={confirm} minLength={8} maxLength={128}
                     onChange={(e) => setConfirm(e.target.value)} required />
              <p className="inv-hint">8 caractères minimum.</p>
              <button type="submit" className="rc-btn rc-btn-primary inv-btn"
                      disabled={saving}>
                {saving ? "Création..." : "Créer mon compte"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default InvitationAccept;
